import React, { useState } from "react";
import { SiGooglemarketingplatform } from "react-icons/si";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
} from "@headlessui/react";
const userNavigation = [
  { name: "Your profile", href: "#", type: "nav" },
  { name: "Sign out", href: "#", type: "button" },
];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function MegaNavbar() {
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  const { auth } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showMegaMenu1, setShowMegaMenu1] = useState(false);
  const [showMegaMenu2, setShowMegaMenu2] = useState(false);
  const [showMegaMenu3, setShowMegaMenu3] = useState(false);

  return (
    <>
      <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
        <div
          aria-hidden="true"
          className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        >
          <div
            style={{
              clipPath:
                "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
            }}
            className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
          />
        </div>
        <div
          aria-hidden="true"
          className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        >
          <div
            style={{
              clipPath:
                "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
            }}
            className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
          />
        </div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <p className="text-sm/6 text-gray-900">
            <strong className="font-semibold"> Welcome to BrainboxStudy</strong>
            <svg
              viewBox="0 0 2 2"
              aria-hidden="true"
              className="mx-2 inline size-0.5 fill-current"
            >
              <circle r={1} cx={1} cy={1} />
            </svg>
            Start Your IT Learning Journey!
          </p>

          <div className="relative inline-block text-left">
            {auth ? (
              <Link
                to={`/dashboard/${auth.user_type}`}
                className={`${true ? "bg-blue-gray-800" : "bg-gray-700"
                  } block px-4  text-sm text-white rounded-full transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-blue-gray-700`}
              >
                Profile
              </Link>

            ) : (
              <Link
                to="/login"
                className="bg-black hover:bg-[#004d66] text-white text-base font-semibold py-2 px-3 rounded-md"
              >
                Get Started
              </Link>
            )}
          </div>
        </div>
        <div className="flex flex-1 justify-end"></div>
      </div>

      <header className=" z-10 relative bg-white shadow-sm border-b">
        <div className="">
          <div className="max-w-7xl py-2 px-4 mx-auto">
            <div className="relative z-10">
              <div className="">
                <div className="flex justify-between  items-center">
                  <div className=" ">
                    <Link
                      to="/"
                      className="flex cursor-pointer items-center whitespace-nowrap text-2xl font-black"
                    >
                      <img src="/brainboxstudy.png" className="w-20" alt="brain box study" />
                    </Link>

                    <button
                      onClick={() => setOpen(!open)}
                      id="navbarToggler"
                      className={`  ${open && "navbarTogglerActive"
                        } absolute right-4 top-1/2  block -translate-y-1/2 rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden`}
                    >
                      <span className="relative my-[6px] block h-[2px] w-[30px] bg-body-color bg-gray-900"></span>
                      <span className="relative my-[6px] block h-[2px] w-[30px] bg-body-color bg-gray-900"></span>
                      <span className="relative my-[6px] block h-[2px] w-[30px] bg-body-color bg-gray-900"></span>
                    </button>
                  </div>
                  <nav
                    className={`absolute lg:static top-full right-4 bg-white shadow-lg lg:shadow-none rounded-lg lg:flex lg:space-x-6 p-4 lg:p-0 ${open ? "block" : "hidden"}`}
                  >
                    {/* <ul className="block lg:flex justify-end text-gray-900">
                      <li>
                        <Link
                          to='/'
                          className="flex hover:bg-gray-800 hover:text-white px-3 py-2  w-full items-center justify-between gap-2 rounded-md text-base font-medium  lg:ml-6 lg:inline-flex lg:w-auto lg:justify-center text-gray-800-6"
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/blogs/list"
                          className="flex cursor-pointer hover:bg-gray-800 hover:text-white px-3 py-2  w-full items-center justify-between gap-2 rounded-md text-base font-medium  lg:ml-6 lg:inline-flex lg:w-auto lg:justify-center text-gray-800-6"
                        >
                          Blogs
                        </Link>
                      </li>

                     
                      <li>
                        <Link
                          to="/about"
                          className="flex text-base font-medium hover:bg-gray-800 hover:text-white px-3 py-2 rounded-md lg:ml-6 lg:inline-flex dark:text-gray-800-6"
                        >
                          About
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/service"
                          className="flex text-base font-medium hover:bg-gray-800 hover:text-white px-3 py-2 rounded-md lg:ml-6 lg:inline-flex dark:text-gray-800-6"
                        >
                          Services
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/Contact"
                          className="flex hover:bg-gray-800 hover:text-white px-2 py-2 rounded-md text-base font-medium lg:ml-6 lg:inline-flex dark:text-gray-800-6"
                        >
                          Contact
                        </Link>
                      </li>
                    </ul> */}
                    {[
                      { name: "Home", path: "/" },
                      { name: "Blogs", path: "/Blogpage" },
                      { name: "About", path: "/about" },
                      { name: "Services", path: "/service" },
                      { name: "Contact", path: "/contact" },
                    ].map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className="block px-4 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-gray-800 hover:text-white lg:inline-block"
                      >
                        {item.name}
                      </Link>
                    ))}
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
